import * as yup from 'yup';
import 'yup-phone';
import { FormFields } from './types';
import { createPhoneValidator } from '../LoginForm/components/phoneValidationUtils';

export const validationSchema = (phoneMask?: string, countryCode?: string) =>
  yup.object().shape({
    [FormFields.Phone]: createPhoneValidator(phoneMask, countryCode),
  });
